import { render, staticRenderFns } from "./pickup-points-edit.vue?vue&type=template&id=6735432c&"
import script from "./pickup-points-edit.vue?vue&type=script&lang=js&"
export * from "./pickup-points-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports